<template>
    <div class="group-builder">

        <div class="group-name d-flex align-items-center">
            <template v-if="editing">
                <button class="btn btn-link" @click.prevent="editing = false"><i class="fas fa-save"></i></button>
                <input ref="input" type="text" class="form-control" v-model="name" placeholder="Group Name" @keyup.enter="editing = false" @blur="editing = false">
            </template>
            <template v-else>
                <button class="btn btn-link" @click="editing = true"><i class="fas fa-pencil-alt"></i></button>
                <label class="m-0">{{ name }}</label>
            </template>

            <div class="buttons flex-shrink-0 ml-auto">
                <button class="btn btn-link text-danger" @click="remove" v-if="!isRoot"><i class="fas fa-trash"></i></button>
                <button class="btn btn-link" @click="addChild" v-if="!depthLimitReached"><i class="fas fa-plus"></i></button>
            </div>

        </div>

        <div class="children pl-4">
            <group-builder ref="children" v-for="(child, index) in children" :key="identify(index)" :group="child" :index="index" @remove="remove(index)" class="child border-top border-info"></group-builder>
        </div>

    </div>
</template>

<script>
import _ from 'lodash'

export default {
    name: 'GroupBuilder',
    props: ['group', 'index'],
    data () {
        return _.defaults({ }, this.group, {
            key: this.group.id || this.group.name,
            children: [],
            editing: false
        })
    },
    computed: {
        isRoot () {
            return !this.parent_id
        },
        depthLimitReached () {
            return this.depth >= 4 // this is an arbitrary limit to avoid nonsense
        }
    },
    methods: {
        addChild () {
            const name = _.uniqueId('Group ')
            this.children.push({
                key: name,
                name: name,
                parent_id: this.id,
                depth: this.depth + 1,
                children: [],
                editing: true
            })
        },
        remove (index) {
            if (index >= 0) {
                this.children.splice(index, 1)
            } else if (this.parent_id) {
                this.$emit('remove')
            }
        },
        identify (index) {
            return this.index + '-' + index
        },
        getData () {
            const data = { name: this.name }

            if (this.id) {
                data.id = this.id
            }

            if (this.parent_id) {
                data.parent_id = this.parent_id
            }

            if (this.children.length) {
                data.children = _.invokeMap(this.$refs.children, 'getData')
            }
            
            return data
        }
    },
    mounted () {
        if (this.editing) {
            this.$refs.input.focus()
        }
    }
}
</script>

<style lang="scss">

</style>
